module.exports = __webpack_public_path__ + "static/media/hourglassIllustration.0f670d30.svg";